module.exports = __webpack_public_path__ + "static/Joystream_Thumbnail_2-f21e28711fece3d09d4aedce253d25ad.jpeg";